/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Supervizor APIs
 * Here is the list of the API endpoints of Supervizor. Click on one to display its implementation. 

Some APIs are protected and require a Bearer token in the Authorization header
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BulkUpdateControlResultOwnerRequestDto,
  BulkUpdateControlResultPriorityRequestDto,
  BulkUpdateControlResultWorkflowStepRequestDto,
  GetControlResultActivitiesResponseDto,
  GetControlResultDetailsResponseDto,
  GetControlResultListPaginatedParams,
  GetControlResultListPaginatedResponseDto,
  GetControlResultSourceListPaginatedParams,
  GetControlResultSourceListPaginatedResponseDto,
  UpdateControlResultOwnerDto,
  UpdateControlResultPriorityRequestDto,
  UpdateControlResultWorkflowStepRequestDto
} from '.././model';

import { customAxiosInstance } from '../../axios/axiosInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Get control result list paginated
 */
export const getControlResultListPaginated = (
    controlId: string,
    params: GetControlResultListPaginatedParams,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetControlResultListPaginatedResponseDto>(
      {url: `/controls/${controlId}/results`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetControlResultListPaginatedQueryKey = (controlId?: string,
    params?: GetControlResultListPaginatedParams,) => {
    return [`/controls/${controlId}/results`, ...(params ? [params]: [])] as const;
    }

    
export const getGetControlResultListPaginatedQueryOptions = <TData = Awaited<ReturnType<typeof getControlResultListPaginated>>, TError = unknown>(controlId: string,
    params: GetControlResultListPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultListPaginated>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetControlResultListPaginatedQueryKey(controlId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getControlResultListPaginated>>> = ({ signal }) => getControlResultListPaginated(controlId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(controlId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getControlResultListPaginated>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetControlResultListPaginatedQueryResult = NonNullable<Awaited<ReturnType<typeof getControlResultListPaginated>>>
export type GetControlResultListPaginatedQueryError = unknown


export function useGetControlResultListPaginated<TData = Awaited<ReturnType<typeof getControlResultListPaginated>>, TError = unknown>(
 controlId: string,
    params: GetControlResultListPaginatedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultListPaginated>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getControlResultListPaginated>>,
          TError,
          Awaited<ReturnType<typeof getControlResultListPaginated>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetControlResultListPaginated<TData = Awaited<ReturnType<typeof getControlResultListPaginated>>, TError = unknown>(
 controlId: string,
    params: GetControlResultListPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultListPaginated>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getControlResultListPaginated>>,
          TError,
          Awaited<ReturnType<typeof getControlResultListPaginated>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetControlResultListPaginated<TData = Awaited<ReturnType<typeof getControlResultListPaginated>>, TError = unknown>(
 controlId: string,
    params: GetControlResultListPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultListPaginated>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get control result list paginated
 */

export function useGetControlResultListPaginated<TData = Awaited<ReturnType<typeof getControlResultListPaginated>>, TError = unknown>(
 controlId: string,
    params: GetControlResultListPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultListPaginated>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetControlResultListPaginatedQueryOptions(controlId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get control result list paginated
 */
export const getControlResultSourceListPaginated = (
    controlId: string,
    controlResultId: string,
    params: GetControlResultSourceListPaginatedParams,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetControlResultSourceListPaginatedResponseDto>(
      {url: `/controls/${controlId}/results/${controlResultId}/source`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetControlResultSourceListPaginatedQueryKey = (controlId?: string,
    controlResultId?: string,
    params?: GetControlResultSourceListPaginatedParams,) => {
    return [`/controls/${controlId}/results/${controlResultId}/source`, ...(params ? [params]: [])] as const;
    }

    
export const getGetControlResultSourceListPaginatedQueryOptions = <TData = Awaited<ReturnType<typeof getControlResultSourceListPaginated>>, TError = null | null>(controlId: string,
    controlResultId: string,
    params: GetControlResultSourceListPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultSourceListPaginated>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetControlResultSourceListPaginatedQueryKey(controlId,controlResultId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getControlResultSourceListPaginated>>> = ({ signal }) => getControlResultSourceListPaginated(controlId,controlResultId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(controlId && controlResultId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getControlResultSourceListPaginated>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetControlResultSourceListPaginatedQueryResult = NonNullable<Awaited<ReturnType<typeof getControlResultSourceListPaginated>>>
export type GetControlResultSourceListPaginatedQueryError = null | null


export function useGetControlResultSourceListPaginated<TData = Awaited<ReturnType<typeof getControlResultSourceListPaginated>>, TError = null | null>(
 controlId: string,
    controlResultId: string,
    params: GetControlResultSourceListPaginatedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultSourceListPaginated>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getControlResultSourceListPaginated>>,
          TError,
          Awaited<ReturnType<typeof getControlResultSourceListPaginated>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetControlResultSourceListPaginated<TData = Awaited<ReturnType<typeof getControlResultSourceListPaginated>>, TError = null | null>(
 controlId: string,
    controlResultId: string,
    params: GetControlResultSourceListPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultSourceListPaginated>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getControlResultSourceListPaginated>>,
          TError,
          Awaited<ReturnType<typeof getControlResultSourceListPaginated>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetControlResultSourceListPaginated<TData = Awaited<ReturnType<typeof getControlResultSourceListPaginated>>, TError = null | null>(
 controlId: string,
    controlResultId: string,
    params: GetControlResultSourceListPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultSourceListPaginated>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get control result list paginated
 */

export function useGetControlResultSourceListPaginated<TData = Awaited<ReturnType<typeof getControlResultSourceListPaginated>>, TError = null | null>(
 controlId: string,
    controlResultId: string,
    params: GetControlResultSourceListPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultSourceListPaginated>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetControlResultSourceListPaginatedQueryOptions(controlId,controlResultId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get specific control result
 */
export const getControlResult = (
    controlId: string,
    resultId: string,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetControlResultDetailsResponseDto>(
      {url: `/controls/${controlId}/results/${resultId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetControlResultQueryKey = (controlId?: string,
    resultId?: string,) => {
    return [`/controls/${controlId}/results/${resultId}`] as const;
    }

    
export const getGetControlResultQueryOptions = <TData = Awaited<ReturnType<typeof getControlResult>>, TError = null | null>(controlId: string,
    resultId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResult>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetControlResultQueryKey(controlId,resultId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getControlResult>>> = ({ signal }) => getControlResult(controlId,resultId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(controlId && resultId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getControlResult>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetControlResultQueryResult = NonNullable<Awaited<ReturnType<typeof getControlResult>>>
export type GetControlResultQueryError = null | null


export function useGetControlResult<TData = Awaited<ReturnType<typeof getControlResult>>, TError = null | null>(
 controlId: string,
    resultId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResult>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getControlResult>>,
          TError,
          Awaited<ReturnType<typeof getControlResult>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetControlResult<TData = Awaited<ReturnType<typeof getControlResult>>, TError = null | null>(
 controlId: string,
    resultId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResult>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getControlResult>>,
          TError,
          Awaited<ReturnType<typeof getControlResult>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetControlResult<TData = Awaited<ReturnType<typeof getControlResult>>, TError = null | null>(
 controlId: string,
    resultId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResult>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get specific control result
 */

export function useGetControlResult<TData = Awaited<ReturnType<typeof getControlResult>>, TError = null | null>(
 controlId: string,
    resultId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResult>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetControlResultQueryOptions(controlId,resultId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update control result owner
 */
export const updateControlResultOwner = (
    controlId: string,
    resultId: string,
    updateControlResultOwnerDto: UpdateControlResultOwnerDto,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<null>(
      {url: `/controls/${controlId}/results/${resultId}/owner`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateControlResultOwnerDto
    },
      options);
    }
  


export const getUpdateControlResultOwnerMutationOptions = <TError = null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateControlResultOwner>>, TError,{controlId: string;resultId: string;data: UpdateControlResultOwnerDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateControlResultOwner>>, TError,{controlId: string;resultId: string;data: UpdateControlResultOwnerDto}, TContext> => {

const mutationKey = ['updateControlResultOwner'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateControlResultOwner>>, {controlId: string;resultId: string;data: UpdateControlResultOwnerDto}> = (props) => {
          const {controlId,resultId,data} = props ?? {};

          return  updateControlResultOwner(controlId,resultId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateControlResultOwnerMutationResult = NonNullable<Awaited<ReturnType<typeof updateControlResultOwner>>>
    export type UpdateControlResultOwnerMutationBody = UpdateControlResultOwnerDto
    export type UpdateControlResultOwnerMutationError = null | null | null

    /**
 * @summary Update control result owner
 */
export const useUpdateControlResultOwner = <TError = null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateControlResultOwner>>, TError,{controlId: string;resultId: string;data: UpdateControlResultOwnerDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateControlResultOwner>>,
        TError,
        {controlId: string;resultId: string;data: UpdateControlResultOwnerDto},
        TContext
      > => {

      const mutationOptions = getUpdateControlResultOwnerMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Update control result transisions
 */
export const updateWorkflowStep = (
    controlId: string,
    resultId: string,
    updateControlResultWorkflowStepRequestDto: UpdateControlResultWorkflowStepRequestDto,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<null>(
      {url: `/controls/${controlId}/results/${resultId}/workflow-step`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateControlResultWorkflowStepRequestDto
    },
      options);
    }
  


export const getUpdateWorkflowStepMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkflowStep>>, TError,{controlId: string;resultId: string;data: UpdateControlResultWorkflowStepRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateWorkflowStep>>, TError,{controlId: string;resultId: string;data: UpdateControlResultWorkflowStepRequestDto}, TContext> => {

const mutationKey = ['updateWorkflowStep'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorkflowStep>>, {controlId: string;resultId: string;data: UpdateControlResultWorkflowStepRequestDto}> = (props) => {
          const {controlId,resultId,data} = props ?? {};

          return  updateWorkflowStep(controlId,resultId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorkflowStepMutationResult = NonNullable<Awaited<ReturnType<typeof updateWorkflowStep>>>
    export type UpdateWorkflowStepMutationBody = UpdateControlResultWorkflowStepRequestDto
    export type UpdateWorkflowStepMutationError = unknown

    /**
 * @summary Update control result transisions
 */
export const useUpdateWorkflowStep = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkflowStep>>, TError,{controlId: string;resultId: string;data: UpdateControlResultWorkflowStepRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateWorkflowStep>>,
        TError,
        {controlId: string;resultId: string;data: UpdateControlResultWorkflowStepRequestDto},
        TContext
      > => {

      const mutationOptions = getUpdateWorkflowStepMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Get control result activities
 */
export const getControlResultActivities = (
    controlId: string,
    resultId: string,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetControlResultActivitiesResponseDto>(
      {url: `/controls/${controlId}/results/${resultId}/activities`, method: 'GET', signal
    },
      options);
    }
  

export const getGetControlResultActivitiesQueryKey = (controlId?: string,
    resultId?: string,) => {
    return [`/controls/${controlId}/results/${resultId}/activities`] as const;
    }

    
export const getGetControlResultActivitiesQueryOptions = <TData = Awaited<ReturnType<typeof getControlResultActivities>>, TError = unknown>(controlId: string,
    resultId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultActivities>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetControlResultActivitiesQueryKey(controlId,resultId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getControlResultActivities>>> = ({ signal }) => getControlResultActivities(controlId,resultId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(controlId && resultId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getControlResultActivities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetControlResultActivitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getControlResultActivities>>>
export type GetControlResultActivitiesQueryError = unknown


export function useGetControlResultActivities<TData = Awaited<ReturnType<typeof getControlResultActivities>>, TError = unknown>(
 controlId: string,
    resultId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultActivities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getControlResultActivities>>,
          TError,
          Awaited<ReturnType<typeof getControlResultActivities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetControlResultActivities<TData = Awaited<ReturnType<typeof getControlResultActivities>>, TError = unknown>(
 controlId: string,
    resultId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultActivities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getControlResultActivities>>,
          TError,
          Awaited<ReturnType<typeof getControlResultActivities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetControlResultActivities<TData = Awaited<ReturnType<typeof getControlResultActivities>>, TError = unknown>(
 controlId: string,
    resultId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultActivities>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get control result activities
 */

export function useGetControlResultActivities<TData = Awaited<ReturnType<typeof getControlResultActivities>>, TError = unknown>(
 controlId: string,
    resultId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultActivities>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetControlResultActivitiesQueryOptions(controlId,resultId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Bulk update control result owner
 */
export const bulkUpdateControlResultOwner = (
    controlId: string,
    bulkUpdateControlResultOwnerRequestDto: BulkUpdateControlResultOwnerRequestDto,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<null>(
      {url: `/controls/${controlId}/results/bulk/owner`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkUpdateControlResultOwnerRequestDto, signal
    },
      { timeout: 30000,  ...options});
    }
  


export const getBulkUpdateControlResultOwnerMutationOptions = <TError = null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateControlResultOwner>>, TError,{controlId: string;data: BulkUpdateControlResultOwnerRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateControlResultOwner>>, TError,{controlId: string;data: BulkUpdateControlResultOwnerRequestDto}, TContext> => {

const mutationKey = ['bulkUpdateControlResultOwner'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkUpdateControlResultOwner>>, {controlId: string;data: BulkUpdateControlResultOwnerRequestDto}> = (props) => {
          const {controlId,data} = props ?? {};

          return  bulkUpdateControlResultOwner(controlId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BulkUpdateControlResultOwnerMutationResult = NonNullable<Awaited<ReturnType<typeof bulkUpdateControlResultOwner>>>
    export type BulkUpdateControlResultOwnerMutationBody = BulkUpdateControlResultOwnerRequestDto
    export type BulkUpdateControlResultOwnerMutationError = null | null | null

    /**
 * @summary Bulk update control result owner
 */
export const useBulkUpdateControlResultOwner = <TError = null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateControlResultOwner>>, TError,{controlId: string;data: BulkUpdateControlResultOwnerRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkUpdateControlResultOwner>>,
        TError,
        {controlId: string;data: BulkUpdateControlResultOwnerRequestDto},
        TContext
      > => {

      const mutationOptions = getBulkUpdateControlResultOwnerMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Execute workflow transitions (Start Investigation, Complete Investigation, Restart Investigation, Exclude, Include) on multiple selected results simultaneously
 * @summary Bulk update workflow step for multiple control results
 */
export const bulkUpdateControlResultWorkflowStep = (
    controlId: string,
    bulkUpdateControlResultWorkflowStepRequestDto: BulkUpdateControlResultWorkflowStepRequestDto,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<null>(
      {url: `/controls/${controlId}/results/bulk/workflow-step`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkUpdateControlResultWorkflowStepRequestDto, signal
    },
      { timeout: 30000,  ...options});
    }
  


export const getBulkUpdateControlResultWorkflowStepMutationOptions = <TError = null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateControlResultWorkflowStep>>, TError,{controlId: string;data: BulkUpdateControlResultWorkflowStepRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateControlResultWorkflowStep>>, TError,{controlId: string;data: BulkUpdateControlResultWorkflowStepRequestDto}, TContext> => {

const mutationKey = ['bulkUpdateControlResultWorkflowStep'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkUpdateControlResultWorkflowStep>>, {controlId: string;data: BulkUpdateControlResultWorkflowStepRequestDto}> = (props) => {
          const {controlId,data} = props ?? {};

          return  bulkUpdateControlResultWorkflowStep(controlId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BulkUpdateControlResultWorkflowStepMutationResult = NonNullable<Awaited<ReturnType<typeof bulkUpdateControlResultWorkflowStep>>>
    export type BulkUpdateControlResultWorkflowStepMutationBody = BulkUpdateControlResultWorkflowStepRequestDto
    export type BulkUpdateControlResultWorkflowStepMutationError = null | null | null

    /**
 * @summary Bulk update workflow step for multiple control results
 */
export const useBulkUpdateControlResultWorkflowStep = <TError = null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateControlResultWorkflowStep>>, TError,{controlId: string;data: BulkUpdateControlResultWorkflowStepRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkUpdateControlResultWorkflowStep>>,
        TError,
        {controlId: string;data: BulkUpdateControlResultWorkflowStepRequestDto},
        TContext
      > => {

      const mutationOptions = getBulkUpdateControlResultWorkflowStepMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Update control result priority
 */
export const updateControlResultPriority = (
    controlId: string,
    resultId: string,
    updateControlResultPriorityRequestDto: UpdateControlResultPriorityRequestDto,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<null>(
      {url: `/controls/${controlId}/results/${resultId}/priority`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateControlResultPriorityRequestDto, signal
    },
      options);
    }
  


export const getUpdateControlResultPriorityMutationOptions = <TError = null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateControlResultPriority>>, TError,{controlId: string;resultId: string;data: UpdateControlResultPriorityRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateControlResultPriority>>, TError,{controlId: string;resultId: string;data: UpdateControlResultPriorityRequestDto}, TContext> => {

const mutationKey = ['updateControlResultPriority'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateControlResultPriority>>, {controlId: string;resultId: string;data: UpdateControlResultPriorityRequestDto}> = (props) => {
          const {controlId,resultId,data} = props ?? {};

          return  updateControlResultPriority(controlId,resultId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateControlResultPriorityMutationResult = NonNullable<Awaited<ReturnType<typeof updateControlResultPriority>>>
    export type UpdateControlResultPriorityMutationBody = UpdateControlResultPriorityRequestDto
    export type UpdateControlResultPriorityMutationError = null | null | null

    /**
 * @summary Update control result priority
 */
export const useUpdateControlResultPriority = <TError = null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateControlResultPriority>>, TError,{controlId: string;resultId: string;data: UpdateControlResultPriorityRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateControlResultPriority>>,
        TError,
        {controlId: string;resultId: string;data: UpdateControlResultPriorityRequestDto},
        TContext
      > => {

      const mutationOptions = getUpdateControlResultPriorityMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Bulk update control result priority
 */
export const bulkUpdateControlResultPriority = (
    controlId: string,
    bulkUpdateControlResultPriorityRequestDto: BulkUpdateControlResultPriorityRequestDto,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<null>(
      {url: `/controls/${controlId}/results/bulk/priority`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkUpdateControlResultPriorityRequestDto, signal
    },
      { timeout: 30000,  ...options});
    }
  


export const getBulkUpdateControlResultPriorityMutationOptions = <TError = null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateControlResultPriority>>, TError,{controlId: string;data: BulkUpdateControlResultPriorityRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateControlResultPriority>>, TError,{controlId: string;data: BulkUpdateControlResultPriorityRequestDto}, TContext> => {

const mutationKey = ['bulkUpdateControlResultPriority'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkUpdateControlResultPriority>>, {controlId: string;data: BulkUpdateControlResultPriorityRequestDto}> = (props) => {
          const {controlId,data} = props ?? {};

          return  bulkUpdateControlResultPriority(controlId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BulkUpdateControlResultPriorityMutationResult = NonNullable<Awaited<ReturnType<typeof bulkUpdateControlResultPriority>>>
    export type BulkUpdateControlResultPriorityMutationBody = BulkUpdateControlResultPriorityRequestDto
    export type BulkUpdateControlResultPriorityMutationError = null | null

    /**
 * @summary Bulk update control result priority
 */
export const useBulkUpdateControlResultPriority = <TError = null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateControlResultPriority>>, TError,{controlId: string;data: BulkUpdateControlResultPriorityRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkUpdateControlResultPriority>>,
        TError,
        {controlId: string;data: BulkUpdateControlResultPriorityRequestDto},
        TContext
      > => {

      const mutationOptions = getBulkUpdateControlResultPriorityMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    